import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslationApp } from "../../../../lib/i18next";
import { CAMPAIGN_APPROVAL_PANEL_TITLE } from "../../../../i18n/keysTranslations";
import {
  BOX_SHADOW_FIELDS,
  INPUT_COLOR_BORDER,
} from "../../../../utils/colors";
import { BORDER_RADIUS } from "../../../../utils/constants";

const SHOW_HINT = false;

const ApprovalCommentFieldHint = ({
  anchorEl = null,
  body = "",
  open = false,
  onClose = () => {},
}) => {
  const { t } = useTranslationApp();

  if (!open || !anchorEl || !body?.trim() || !SHOW_HINT) {
    return null;
  }

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="top"
      sx={{ zIndex: 1000 }}
      arrow
      modifiers={[
        { name: "offset", options: { offset: [0, 10] } },
        { name: "preventOverflow", options: { padding: 12 } },
        {
          name: "flip",
          options: { fallbackPlacements: ["bottom", "right", "left"] },
        },
      ]}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: 320,
          p: 1.5,
          backgroundColor: "fields.background",
          color: "background.paperContrastText",
          border: `1px solid ${INPUT_COLOR_BORDER}`,
          borderRadius: BORDER_RADIUS,
          boxShadow: BOX_SHADOW_FIELDS,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 0.5,
            mb: 0.75,
          }}
        >
          <Typography
            variant="caption"
            sx={{
              display: "block",
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: "0.04em",
              color: "text.secondary",
              pt: 0.25,
            }}
          >
            {t(CAMPAIGN_APPROVAL_PANEL_TITLE)}
          </Typography>

          <IconButton
            size="small"
            aria-label="close"
            onClick={onClose}
            sx={{
              mt: -0.5,
              mr: -0.5,
              color: "text.secondary",
            }}
          >
            <CloseIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </Box>

        <Typography
          variant="body2"
          sx={{ whiteSpace: "pre-wrap", color: "text.primary" }}
        >
          {body}
        </Typography>
      </Paper>
    </Popper>
  );
};

export default ApprovalCommentFieldHint;
